import { render } from "./homeFooter.vue?vue&type=template&id=79dd7135&scoped=true"
const script = {}

import "./homeFooter.vue?vue&type=style&index=0&id=79dd7135&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79dd7135"]])

export default __exports__